import { render, staticRenderFns } from "./childInfoModal.vue?vue&type=template&id=c72b71f2"
import script from "./childInfoModal.vue?vue&type=script&lang=js"
export * from "./childInfoModal.vue?vue&type=script&lang=js"
import style0 from "./childInfoModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports